import assetUrl from 'src/common/utils/assetUrl';

export const defaultBrickImageSrc = assetUrl(
  'assets/img/default-item-brick-v2.png',
);
